export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  AGENT: 'agent',
  CUSTOMER_SERVICE: 'customer_service',
  BACK_OFFICE: 'back_office',
  CROATIAN_TEAM: 'croatian_team',
  AUTH_ACCESS: 'auth_access'
}

export const ROLE_LABELS = {
  [USER_ROLES.ADMIN]: 'Admin',
  [USER_ROLES.MANAGER]: 'Manager',
  [USER_ROLES.AGENT]: 'Agent',
  [USER_ROLES.CUSTOMER_SERVICE]: 'Customer Service',
  [USER_ROLES.BACK_OFFICE]: 'Back Office',
  [USER_ROLES.CROATIAN_TEAM]: 'Croatian Team',
  [USER_ROLES.AUTH_ACCESS]: 'Auth Access'
}

export const IVA_PROMO_ALLOWED_ROLES = [
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.AUTH_ACCESS
]

export const canToggleIvaPromo = role =>
  IVA_PROMO_ALLOWED_ROLES.includes(role?.toLowerCase?.())

export const isValidRole = role => {
  return Object.values(USER_ROLES).includes(role?.toLowerCase())
}

export const normalizeRole = role => {
  const normalizedRole = role?.toLowerCase()
  return isValidRole(normalizedRole) ? normalizedRole : USER_ROLES.AGENT // default to agent if invalid role
}

export const getRoleLabel = role => {
  const normalizedRole = normalizeRole(role)
  return ROLE_LABELS[normalizedRole] || ROLE_LABELS[USER_ROLES.AGENT]
}

export const hasRole = (userRole, requiredRole) => {
  const normalizedUserRole = normalizeRole(userRole)
  const normalizedRequiredRole = normalizeRole(requiredRole)

  if (normalizedUserRole === USER_ROLES.ADMIN) return true
  if (normalizedUserRole === USER_ROLES.AUTH_ACCESS) return true
  if (
    normalizedUserRole === USER_ROLES.MANAGER &&
    normalizedRequiredRole !== USER_ROLES.ADMIN
  )
    return true
  if (
    normalizedUserRole === USER_ROLES.AGENT &&
    normalizedRequiredRole === USER_ROLES.AGENT
  )
    return true

  return false
}
